(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-announcement-bar"] && !Shopify.designMode) return;
  try {
    
function initMarquee(container) {
  if (!container) return;
  const wrapper = container.querySelector('[ref="wrapper"]');
  const content = container.querySelector('[ref="content"]');
  let items = Array.from(container.querySelectorAll('[ref="marqueeItems"]'));
  let offset = 0;
  let pixelsPerSecond = 1;

  function applySettings() {
    const styles = getComputedStyle(container);
    const speedSlider = parseFloat(styles.getPropertyValue('--marquee-speed')) || 30;
    const direction = styles.getPropertyValue('--marquee-direction').trim() === 'reverse' ? -1 : 1;
    const gap = parseFloat(styles.getPropertyValue('--marquee-gap')) || 20;
    return { speedSlider, direction, gap };
  }

  function updateGap() {
    const { gap } = applySettings();
    wrapper.style.gap = gap + 'px';
    wrapper.querySelectorAll('.marquee-separator').forEach(s => {
      s.style.margin = `0 ${gap/2}px`;
    });
    wrapper.querySelectorAll('.marquee-announcement__text').forEach(t => {
      t.style.padding = `0 ${gap}px`;
    });
  }

  function duplicateItems() {
    const wrapperWidth = wrapper.offsetWidth;
    let contentWidth = content.scrollWidth;
    let cloneCount = 0;
    while (contentWidth < wrapperWidth * 2) {
      items.forEach(item => content.appendChild(item.cloneNode(true)));
      items = Array.from(container.querySelectorAll('[ref="marqueeItems"]'));
      contentWidth = content.scrollWidth;
      cloneCount++;
      if (cloneCount > 10) break;
    }
    const { speedSlider } = applySettings();
    pixelsPerSecond = content.scrollWidth / speedSlider; // same speed desktop/mobile
  }

  function animate(timestamp) {
    if (!animate.lastTime) animate.lastTime = timestamp;
    const delta = timestamp - animate.lastTime;
    animate.lastTime = timestamp;

    const { direction } = applySettings();
    offset += (delta / 1000) * pixelsPerSecond * direction;
    content.style.transform = `translateX(${-offset}px)`;

    const halfWidth = content.scrollWidth / 2;
    if (Math.abs(offset) >= halfWidth) offset = 0;

    requestAnimationFrame(animate);
  }

  function start() {
    updateGap();
    duplicateItems();
    requestAnimationFrame(animate);
  }

  window.addEventListener('resize', () => {
    offset = 0;
    items = Array.from(container.querySelectorAll('[ref="marqueeItems"]'));
    updateGap();
    duplicateItems();
  });

  start();
}

// Initialize all marquees
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('section[marquee-component]').forEach(initMarquee);
});

// Shopify live editor support
['shopify:section:load','shopify:section:select','shopify:block:select','shopify:block:deselect'].forEach(eventName => {
  document.addEventListener(eventName, e => {
    const section = e.target.querySelector ? e.target.querySelector('section[marquee-component]') : null;
    if (section) initMarquee(section);
  });
});

  } catch(e) { console.error(e); }
})();
})();
